import React from 'react'
import { Slider as AntSlider } from 'antd'
import { SliderRangeProps as AntSliderProps } from 'antd/lib/slider'

export type SliderProps = AntSliderProps

export const Slider: React.FC<SliderProps> = ({
  range,
  defaultValue,
  onChange,
  value,
  disabled,
  step,
  min,
  max,
  marks,
  tipFormatter
}) => {
  const controlledProps = {
    ...(defaultValue !== undefined && { defaultValue }),
    ...(value !== undefined && { value })
  }

  return (
    <AntSlider
      range={range}
      disabled={disabled}
      onChange={onChange}
      step={step}
      min={min}
      max={max}
      marks={marks}
      tipFormatter={tipFormatter}
      {...controlledProps}
    />
  )
}
